import common from './modules/common'
import './privacypolicy.scss'

window.addEventListener('load', () => {
  common()
})